import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, ShoppingBag, User, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Navbar() {
  const { count, setIsOpen } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const goManifesto = () => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-[70] bg-background border-b-2 border-black">
      <div className="flex items-stretch justify-between">
        <Link
          to="/"
          data-testid="nav-brand"
          className="font-display text-xl sm:text-2xl uppercase px-4 sm:px-6 py-3 border-r-2 border-black hover:bg-primary hover:text-white transition-colors whitespace-nowrap"
        >
          <img src="/logo.png" alt="Fleece The Regime logo" className="h-10 w-10 sm:h-11 sm:w-11 object-contain mr-3 border-2 border-black bg-background" data-testid="nav-logo" />
          Fleece<span className="text-primary">★</span>The&nbsp;Regime
        </Link>
        <nav className="flex items-stretch font-mono text-xs sm:text-sm font-bold uppercase tracking-[0.15em]">
          <Link
            to="/shop"
            data-testid="nav-shop-link"
            className="hidden sm:flex items-center px-5 border-l-2 border-black hover:bg-primary hover:text-white transition-colors"
          >
            Shop
          </Link>
          <Link
            to="/about"
            data-testid="nav-about-link"
            className="hidden sm:flex items-center px-5 border-l-2 border-black hover:bg-primary hover:text-white transition-colors uppercase tracking-[0.15em] font-bold"
          >
            About
          </Link>
          <button
            onClick={goManifesto}
            data-testid="nav-manifesto-link"
            className="hidden sm:flex items-center px-5 border-l-2 border-black hover:bg-primary hover:text-white transition-colors uppercase tracking-[0.15em] font-bold"
          >
            Manifesto
          </button>
          <button
            onClick={() => setMenuOpen((o) => !o)}
            data-testid="nav-menu-button"
            aria-label="Menu"
            className="flex sm:hidden items-center px-4 border-l-2 border-black hover:bg-primary hover:text-white transition-colors"
          >
            {menuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
          <Link
            to="/account"
            data-testid="nav-account-link"
            className="flex items-center px-4 sm:px-5 border-l-2 border-black hover:bg-primary hover:text-white transition-colors uppercase tracking-[0.15em] font-bold"
          >
            <User size={16} className="mr-2" /> Account
          </Link>
          <button
            onClick={() => setIsOpen(true)}
            data-testid="nav-cart-button"
            className="flex items-center gap-2 px-4 sm:px-5 border-l-2 border-black bg-primary text-black hover:bg-black hover:text-white transition-colors"
          >
            <ShoppingBag size={16} /> Cart ({count})
          </button>
        </nav>
      </div>
      {menuOpen && (
        <nav
          data-testid="mobile-menu"
          className="sm:hidden absolute top-full left-0 right-0 bg-background border-b-2 border-black font-mono text-sm font-bold uppercase tracking-[0.15em]"
        >
          <Link
            to="/shop"
            onClick={() => setMenuOpen(false)}
            data-testid="mobile-menu-shop-link"
            className="block px-6 py-4 border-b-2 border-black hover:bg-primary hover:text-white transition-colors"
          >
            Shop
          </Link>
          <Link
            to="/about"
            onClick={() => setMenuOpen(false)}
            data-testid="mobile-menu-about-link"
            className="block px-6 py-4 border-b-2 border-black hover:bg-primary hover:text-white transition-colors"
          >
            About
          </Link>
          <button
            onClick={goManifesto}
            data-testid="mobile-menu-manifesto-link"
            className="block w-full text-left px-6 py-4 hover:bg-primary hover:text-white transition-colors"
          >
            Manifesto
          </button>
        </nav>
      )}
    </header>
  );
}
